import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
function ExplorerFilterTypeBool(parent) {
    var self = this;
    self.ObjectValue = ko.observable();
    self.Save = function () {
        return Bao.post("ExplorerFilter/SaveExplorerFilterDefinitionBool", JSON.stringify({
            objectValue: self.ObjectValue(),
            explorerFilterDefinitionId: parent.SelectedExplorerFilterDefinitionId(),
            sessionTabId: parent.TabPage.SessionTabId
        }), function (result) { });
    };
    self.loaded = function () {
        if (parent != null && parent.ExplorerFilterDefinitionDataSource() != null) {
            var dataSource = parent.ExplorerFilterDefinitionDataSource();
            if (dataSource.ObjectValue != null && typeof dataSource.ObjectValue == "boolean") {
                self.ObjectValue(dataSource.ObjectValue.toString());
            }
        }
        self.ObjectValue.subscribe(function () {
            self.Save();
        });
    };
}
export default ExplorerFilterTypeBool;